export interface ProductTypeSalesUnit {
  id: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  unitOfMeasureKey: string;
  unitOfMeasureShortDescription: string;
}
